import type { ProductAccent } from '@/content/products';

export const accentText: Record<ProductAccent, string> = {
  cyan: 'text-primary',
  coral: 'text-cta',
  violet: 'text-urgency'
};

export const accentBorder: Record<ProductAccent, string> = {
  cyan: 'border-primary/40',
  coral: 'border-cta/40',
  violet: 'border-urgency/40'
};

export const accentSoftBg: Record<ProductAccent, string> = {
  cyan: 'bg-primary/10',
  coral: 'bg-cta/10',
  violet: 'bg-urgency/10'
};

export const accentWash: Record<ProductAccent, string> = {
  cyan: 'from-primary/25 via-primary/5 to-transparent',
  coral: 'from-cta/25 via-cta/5 to-transparent',
  violet: 'from-urgency/25 via-urgency/5 to-transparent'
};

export const accentGlow: Record<ProductAccent, string> = {
  cyan: 'shadow-[0_16px_48px_-28px_rgb(10_122_147_/_0.35)]',
  coral: 'shadow-[0_16px_48px_-28px_rgb(228_87_46_/_0.3)]',
  violet: 'shadow-[0_16px_48px_-28px_rgb(109_40_217_/_0.28)]'
};

export const accentRingDot: Record<ProductAccent, string> = {
  cyan: 'bg-primary',
  coral: 'bg-cta',
  violet: 'bg-urgency'
};
